import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getPartNumberCodeList = (urlParameters = {}) => apiActionCreator({
  'endpoint': `/part-number-code${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PNC_INFO_REQUEST,
    ActionTypes.GET_PNC_INFO_SUCCESS,
    [
      ActionTypes.GET_PNC_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearPncList = () => ({
  'type': ActionTypes.CLEAR_PNC_LIST,
});

export const changePartNumberCodeInformationPage = (newPage) => ({
  'type': ActionTypes.CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE,
  'payload': newPage,
});

export const changePartNumberCodeInformationPageSize = (pageSize) => ({
  'type': ActionTypes.CHANGE_PART_NUMBER_CODE_INFORMATION_PAGE_SIZE,
  'payload': pageSize,
});

export const downloadPncList = (urlParameters = {}) => apiActionCreator({
  'endpoint': `/part-number-code/excel${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOAD_LIST_REQUEST,
    ActionTypes.DOWNLOAD_LIST_SUCCESS,
    [
      ActionTypes.DOWNLOAD_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearPncListUrl = () => ({
  'type': ActionTypes.CLEAR_PNC_LIST_URL,
});
